import Markdown from "components/markdown/markdown";
import TextButton from "components/textButton/TextButtonLegacy";

import type { CareersPageData } from "../types";

type ContactSectionProps = {
  data: CareersPageData["careerPage"];
};

export default function ContactSection({ data }: ContactSectionProps) {
  const { contactSectionHeading, mapsLink, contactMessage, address } = data;
  return (
    <div>
      <h2 className="mb-3 font-bold text-[18px] text-black-rock md:mb-[14px]">
        {contactSectionHeading}
      </h2>

      {mapsLink && (
        <div className="mb-[70px] flex w-100 flex-col md:flex-row">
          <iframe
            title="map"
            src={mapsLink}
            style={{ border: "0" }}
            allowFullScreen={false}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-100"
          ></iframe>
          <div className="flex w-100 flex-col justify-center bg-black-rock px-[17px] py-[30px]">
            <p className="mb-[21px] text-center font-bold text-[18px] leading-[130%] text-white">
              {address}
            </p>
            <TextButton
              target="_blank"
              rel="noreferrer noopener"
              withIcon
              className="mx-auto text-center"
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                address
              )}`}
            >
              View in Google Maps
            </TextButton>
          </div>
        </div>
      )}

      <div className="[&_a]:inline [&_a]:text-cerise [&_a]:underline [&_a]:[text-underline-position:under] focus:[&_a]:outline-none focus-visible:[&_a]:outline-none focus-visible:[&_a]:ring focus-visible:[&_a]:ring-cerise">
        {contactMessage && (
          <Markdown
            className="mx-auto w-[240px] text-center font-recklessBold text-[32px] leading-[130%] md:w-[486px] lg:w-[486px]"
            text={contactMessage}
          />
        )}
      </div>
    </div>
  );
}
